export default "__VITE_ASSET__DY0xh4tM__"